export default "__VITE_ASSET__Wyiq4MKT__"